// Smooth accordion animation that always replays (add before </body>)
document.addEventListener('DOMContentLoaded', () => {

  // Add CSS for transitions
  const style = document.createElement('style');
  style.textContent = `
    .icon-button-arrow {
      transition: transform 0.45s ease !important;
    }

    details[open] > summary .icon-button-arrow {
      transform: rotate(180deg) !important;
    }

    .menu-drawer__submenu {
      transition: max-height 0.45s ease, opacity 0.45s ease !important;
      overflow: hidden !important;
      will-change: max-height, opacity;
    }
  `;
  document.head.appendChild(style);

  // Apply animation to each accordion
  document.querySelectorAll('details').forEach((details) => {
    const submenu = details.querySelector('.menu-drawer__submenu');
    if (!submenu) return;

    // Ensure closed state initially
    if (!details.open) {
      submenu.style.maxHeight = '0px';
      submenu.style.opacity = '0';
    }

    // Animate on toggle
    details.addEventListener('toggle', () => {
      const isOpening = details.open;

      // Reset styles first to ensure animation replays every time
      submenu.style.transition = 'none';
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
      submenu.getBoundingClientRect(); // force reflow
      submenu.style.transition = 'max-height 0.45s ease, opacity 0.45s ease';

      if (isOpening) {
        // Opening
        submenu.style.maxHeight = '0px';
        submenu.style.opacity = '0';
        submenu.getBoundingClientRect(); // reflow again
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        submenu.style.opacity = '1';

        submenu.addEventListener('transitionend', function cleanup(e) {
          if (e.propertyName === 'max-height') {
            submenu.style.maxHeight = 'auto'; // let it expand naturally after animation
            submenu.removeEventListener('transitionend', cleanup);
          }
        });
      } else {
        // Closing
        submenu.style.maxHeight = submenu.scrollHeight + 'px';
        submenu.style.opacity = '1';
        submenu.getBoundingClientRect();
        submenu.style.maxHeight = '0px';
        submenu.style.opacity = '0';
      }
    });
  });
});
